import { Typography } from "@mui/material";
import CrmIntegrationSelect from "../../components/CrmIntegrationSelect";

export default ({
  actionParameters,
  setActionParameters,
  setValidForm,
  getToken,
  companyId,
}: {
  actionParameters: any;
  setActionParameters: (p: any) => void;
  setValidForm: (b: boolean) => void;
  getToken: Function;
  companyId: string;
}) => {
  return (
    <div>
      <div style={{ marginTop: "24px" }}>
        <CrmIntegrationSelect
          value={actionParameters.crmIntegrationId || ""}
          onChange={(integrationId) =>
            setActionParameters({
              ...actionParameters,
              crmIntegrationId: integrationId,
            })
          }
          getToken={getToken as () => Promise<string>}
          companyId={companyId}
          showTooltip={true}
          tooltipText="Select which CRM to sync contacts to. The action will create or update contacts with the row's lead data (email, name, phone, company, etc.)"
          helperText="Contacts will be created or updated in this CRM"
          required={true}
          onValidationChange={setValidForm}
        />
      </div>

      <div style={{ marginTop: "24px" }}>
        <Typography variant="subtitle1">Fields Synced</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          The following fields will be synced to the CRM (if present in the
          row):
        </Typography>
        <ul
          style={{
            marginTop: "8px",
            paddingLeft: "20px",
            color: "text.secondary",
          }}
        >
          <li>
            <strong>Email</strong> (required)
          </li>
          <li>First Name, Last Name</li>
          <li>Phone Number</li>
          <li>Company Name</li>
          <li>Job Title / Headline</li>
          <li>LinkedIn URL</li>
          <li>Website</li>
          <li>Location</li>
        </ul>
      </div>
    </div>
  );
};
